import axios from 'axios';

// Base da API relativa — funciona atrás de reverse-proxy HTTPS em domínio único.
// Em dev pode-se sobrescrever via REACT_APP_API_BASE (ex: http://localhost:3001/api).
const API_URL = process.env.REACT_APP_API_BASE || '/api';

// Instância configurada do axios
const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor: adiciona o token JWT + usuario_id em todas as requisições.
// r85 (Rodada B): o middleware de permissões do backend espera receber o
// usuario_id em algum lugar. Em vez de mexer em cada service, injetamos
// automaticamente via header x-usuario-id — todas as chamadas passam a levar.
// Continua compatível com endpoints antigos que pegam usuario_id da query.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // r85: pega usuario_id do usuário logado em memória
  try {
    const usuarioStr = localStorage.getItem('usuario');
    if (usuarioStr) {
      const u = JSON.parse(usuarioStr);
      if (u?.id) {
        config.headers['x-usuario-id'] = u.id;
      }
    }
  } catch (e) { /* ignora */ }
  return config;
});

const authService = {
  // POST /api/auth/login
  login: async (email, senha) => {
    const response = await api.post('/auth/login', { email, senha });
    return response.data; // { token, usuario }
  },

  // POST /api/auth/forgot-password
  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  // POST /api/auth/reset-password
  resetPassword: async (token, novaSenha) => {
    const response = await api.post('/auth/reset-password', { token, novaSenha });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
  },

  getUsuarioLogado: () => {
    const usuario = localStorage.getItem('usuario');
    return usuario ? JSON.parse(usuario) : null;
  },

  isAutenticado: () => {
    return !!localStorage.getItem('token');
  },
};

export default authService;
export { api };
